import { useState } from "react";
import { motion } from "framer-motion";
import { AiFillEye, AiFillGithub } from "react-icons/ai";

import { AppWrap } from "./../../HOC/AppWrap";
import { MotionWrap } from "./../../HOC/MotionWrap";

import { works } from "../../../constants/works";

import "./Work.scss";

const Work = () => {
  const [filters] = useState(["UI/UX", "Web App", "All"]);
  const [activefilter, setActivefilter] = useState("All");
  const [animatecard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [filterwork, setFilterWork] = useState(works);

  const handleWorkFilter = (filter) => {
    setActivefilter(filter);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (filter === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(filter)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text" style={{ marginTop: 30 }}>
        Mi portafilio &nbsp;
        <span>creativo &nbsp;</span>
      </h2>

      <div className="app__work-filter">
        {filters.map((item, index) => (
          <div
            key={index}
            className={`app__work-filter-item app__flex p-text ${
              activefilter === item ? "item-active" : ""
            }`}
            onClick={() => handleWorkFilter(item)}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animatecard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterwork.map((work, index) => (
          <div key={index} className="app__work-item app__flex">
            <div className="app__work-img app__flex">
              <img src={work.image} loading="lazy" alt="work" />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{
                      duration: 0.25,
                    }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>

                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{
                      duration: 0.25,
                    }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
